// extracted by mini-css-extract-plugin
export default {"lastEditorWrapper":"LastEditor_lastEditorWrapper__iQKjU","lastEditorInner":"LastEditor_lastEditorInner__qweVb","update":"LastEditor_update__fhCs8"};